import clsx from 'clsx';
import { Image } from '../../../Media';
import React from 'react';

const HoverCarousel = ({ mobileImage, desktopImages }) => {
  return (
    <>
      {/* DEKSTOP */}
      <div
        className={clsx(
          'hidden',
          'md:block',
          'absolute',
          'w-full',
          'h-full',
          'top-0 bottom-0 right-0 left-0',
          'transition',
          'group',
          'opacity-0',
          'group-hover:opacity-100'
        )}
      >
        <div className={'shopitem-carousel-images relative h-full w-full'}>
          {desktopImages?.map((variantImage, index) => (
            <div
              className={'absolute left-0 top-0 h-full w-full'}
              // style={{ width }}
              key={variantImage?.media?.file?.url}
            >
              <Image
                width='100%'
                height='100%'
                objectFit='cover'
                bgColor='white'
                placeholder='blurred'
                media={variantImage?.media}
              />
            </div>
          ))}
        </div>
      </div>
      {/* MOBILE */}
      <div
        className={clsx(
          'md:hidden',
          'absolute',
          'w-full',
          'h-full',
          'top-0',
          'transition',
          'duration-500',
          'overflow-hidden',
          'opacity-0',
          'md:opacity-0',
          'group-hover:opacity-100',
          'group-hover:md:opacity-0'
        )}
      >
        <Image
          width='100%'
          height='100%'
          objectFit='cover'
          bgColor='white'
          media={mobileImage}
        />
      </div>
    </>
  );
};

export default HoverCarousel;
